var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.clientId)?_c('div',{staticClass:"google-btn-wrapper"},[_c('v-btn',{staticClass:"google-btn",attrs:{"type":"button","disabled":!_vm.ready},on:{"click":_vm.triggerPrompt}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-google")]),_vm._v(" "+_vm._s(_vm.label)+" ")],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }